import { render } from "./Event.vue?vue&type=template&id=10226d7d&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=10226d7d&scoped=true&lang=scss"

import exportComponent from "/home/ben/code/nft_ticket/nft_ticket_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10226d7d"]])

export default __exports__